import { Box, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";
import InfoIcon from "../../../../assets/icons/info-icon.svg";
import MUITable from "../../../../common/components/mui-table/mui-table";
import {
  FieldArray,
  FormikErrors,
  FormikValues,
  useFormikContext,
} from "formik";
import {
  CompanyFormValues,
  getUserErrorMessage,
  headers,
  userDetails,
} from "../add-new-tenet-helper";
import { User } from "../add-new-tenet-helper";
import { AlertComponent } from "../../../../common/components";
import LeftEllipses from "../../../../assets/icons/left-tenet-bg.svg";
import RightEllipses from "../../../../assets/icons/right-tenant-ellipse.svg";
import DeleteIcon from "../../../../assets/icons/delete-outline.svg";
import _ from "lodash";

interface AddUserProps {
  values: CompanyFormValues;
  errors: FormikErrors<FormikValues>;
  tenetRoles: any[];
}

const AddUser: React.FC<AddUserProps> = ({ values, errors, tenetRoles }) => {
  const [alert, setAlert] = useState<any>(false);

  const { setFieldValue } = useFormikContext<{ [key: string]: any }>();

  const onHandleChange = (rowIndex: number, key: string, value: any) => {
    const userValues: Partial<User>[] = [...values.users];

    userValues[rowIndex] = {
      ...userValues[rowIndex],
      [key]: value,
    };

    setFieldValue("users", userValues);
  };

  const onClose = () => {
    setAlert(false);
  };

  const handleAddUser = (push: any) => {
    const errMessage = getUserErrorMessage(errors.users, values.users, 5);
    if (errMessage) {
      setAlert({
        message: errMessage ? errMessage : "",
        isOpen: true,
      });
      console.error("Validation error:", errMessage);
      return;
    }

    setAlert({
      message:
        "First Name and Last Name cannot be changed once submitted, Please add proper names.",
      type: "warning",
      isOpen: true,
    });
    push({
      ...userDetails,
      roleId: "",
    });
  };

  return (
    <Box
      style={{
        backgroundImage: `url(${RightEllipses}), url(${LeftEllipses})`,
        backgroundRepeat: "no-repeat, no-repeat",
        backgroundPosition: "bottom left, bottom right",
      }}
      sx={{ margin: "0px -20px" }}
    >
      <Box className="add-user-wrapperr">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <Box className="selected-plan-wrapper">
            <h2>Plan Selected:</h2>
            <div className="selected-plan-button">
              {values?.subscriptionPlanId?.plan_name !== "Trial"
                ? _.capitalize(values?.subscriptionPlanId?.plan_type)
                : "15-day Trial"}
            </div>
          </Box>
          <Box className="selected-plan-wrapper">
            <h2 className="company-name">Company:</h2>
            <Tooltip title={values?.companyName || ""} placement="left" arrow>
              <span className="selected-plan-button">
                {values?.companyName}
              </span>
            </Tooltip>
          </Box>
        </Box>

        <Box className="user-table-header">
          <h2>Add User</h2>
          <Box className="info-icon-wrapper">
            <img src={InfoIcon} alt="info" />
            <span>
              User Limit:{" "}
              {values?.subscriptionPlanId?.no_of_users >= 0
                ? values?.subscriptionPlanId?.no_of_users
                : "Unlimited"}{" "}
              Users
            </span>
          </Box>
        </Box>
        <Box sx={{ marginTop: "10px" }}>
          <FieldArray name="users">
            {({ push, remove }) => (
              <>
                <div className="user-table-wrapper">
                  <MUITable
                    headers={headers}
                    data={
                      values?.users?.map((user: any, index: number) => {
                        return {
                          ...user,
                          delete: (
                            <div>
                              <img
                                src={DeleteIcon}
                                alt="delete"
                                className={`delete-icon ${user?.isPrimaryUser ? "delete-icon-disable" : ""}`}
                                onClick={() => {
                                  if (!user?.isPrimaryUser) remove(index);
                                }}
                              />
                            </div>
                          ),
                        };
                      }) || []
                    }
                    isStriped={false}
                    selectDropDownOptions={{
                      roleId: tenetRoles || [],
                    }}
                    onHandleChange={onHandleChange}
                    onSelectChange={(
                      rowIndex: any,
                      header: any,
                      value: any
                    ) => {
                      onHandleChange(rowIndex, header, value);
                    }}
                  />
                </div>

                <Box className="add-user-button-wrapper">
                  <button
                    onClick={() => {
                      handleAddUser(push);
                    }}
                    type="button"
                    disabled={
                      values?.users?.length >=
                        values?.subscriptionPlanId?.no_of_users &&
                      values?.subscriptionPlanId?.no_of_users !== -1
                    }
                  >
                    Add User
                  </button>
                </Box>
              </>
            )}
          </FieldArray>
        </Box>
        {alert?.isOpen && (
          <AlertComponent
            message={
              alert?.type === "warning" ? (
                alert?.message
              ) : (
                <Typography sx={{ fontSize: "13px" }}>
                  {typeof alert?.message === "string"
                    ? "You're doing great! Just clear up the issues below to add the new user.."
                    : "Please fill in all the fields before adding the new user."}
                  <br />
                  {alert?.message}
                </Typography>
              )
            }
            type={alert?.type || "error"}
            open={alert?.isOpen}
            onClose={onClose}
          />
        )}
      </Box>
    </Box>
  );
};

export default AddUser;
